<template>
  <div>
    <Row>
      <Col :xs="24" :sm="24" :md="18" :lg="14">
        <Form
          ref="form"
          :model="forms"
          :label-width="150"
          :disabled="action == 'view' ? true : false"
        >
          <form-body
            :forms="forms"
            :items="items"
            :disabled="action == 'view' ? true : false"
          ></form-body>

          <button-box v-if="action != 'view'">
            <Poptip
              confirm
              title="请检查数据, 再确认提交"
              @on-ok="handleSubmit"
            >
              <button-sub :loading="sloading">保存</button-sub>
            </Poptip>
            <!-- <button @click="handleSubmitKnow" class="knowledge">
            保存并转存知识库
          </button> -->
          </button-box>
        </Form>
      </Col>
    </Row>
    <Modal title="图片预览" v-model="imgVisible">
      <img :src="imgUrl" style="width: 100%" />
    </Modal>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import Change from "./question.vue";

export default {
  extends: baseEdit,
  components: {
    change: Change,
  },
  props: {
    workId: {
      type: String,
      value: "",
    },
    typeId: {
      type: String,
      value: "",
    },
    state: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "editPro",
      key: "id",
      ll: [],
      url: {
        get: "/admin/system/work",
        // add: "/admin/system/work",
        // edit: "/admin/system/work",
      },
      items: [
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
          rules: [{ required: false, trigger: "blur" }],
          onAddress: this.addres,
          onCancel: this.cancel,
        },
        {
          label: "工单类型",
          name: "typeId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
        },
        {
          label: "处理内容",
          name: "maintainerContent",
          value: "",
          dropList: [],
          type: "pullinput",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
          onFocus: this.onTextFocus,
          onChange: this.onTextChange,
          onExtClick: this.onTextExtClick,
        },
        {
          label: "故障原因",
          name: "teackRemark",
          value: "",
          dropList: [],
          type: "select",
          width: "400px",
        },
        {
          label: "产生费用",
          name: "expensesIncurred",
          value: 0,
          type: "input",
          width: "400px",
        },
        {
          label: "维修类型",
          name: "service",
          value: "服务类",
          dropList: [
            { value: "服务类", name: "服务类" },
            { value: "换修类", name: "换修类" },
            { value: "新增类", name: "新增类" },
          ],
          type: "select",
          width: "400px",
        },
        {
          label: "处理方式",
          name: "handleType",
          value: 2,
          dropList: [
            { value: 1, name: "线上处理" },
            { value: 2, name: "现场处理" },
            { value: 3, name: "带回处理" },
            { value: 4, name: "寄修处理" },
          ],
          type: "select",
          width: "400px",
          onChange: this.onSelectHandleTyoe,
        },
        {
          label: "送出时间",
          name: "sendTime",
          value: "",
          // options: {
          //   disabledDate(date) {
          //     return date && date.valueOf() < Date.now() - 86400000;
          //   },
          // },
          type: "kong",
          format: "yyyy-MM-dd HH:mm:ss",
          width: "400px",
          rules: [{ required: true, trigger: "change" }],
        },
        {
          label: "送回时间",
          name: "returnTime",
          value: "",
          // options: {
          //   disabledDate(date) {
          //     return date && date.valueOf() < Date.now() - 86400000;
          //   },
          // },
          type: "kong",
          format: "yyyy-MM-dd HH:mm:ss",
          width: "400px",
          rules: [{ required: true, trigger: "change" }],
        },
        {
          label: "处理状态",
          name: "state",
          value: 2,
          type: "select",
          disabled: false,
          width: "240px",
          dropList: [
            { value: 2, name: "维修中" },
            { value: 3, name: "已完成" },
          ],
        },
        {
          label: "凭证上传",
          name: "avatar",
          value: "",
          type: "avatar",
          desc: "建议图片宽高尺寸512*512像素及以上",
        },
      ],
      forms: {
        repairSource: 1,
        maintainerContent: "",
        teackRemark: "",
      },
    };
  },
  created() {
    if (this.state == 3) {
      this.items[this.getItemIndex("state")].type = "kong";
    }
    this.loadWorkCommon();
    this.loadTypeData();
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  methods: {
    onSelectHandleTyoe(e) {
      console.log(e);
      if (e == 3) {
        this.items.forEach((item) => {
          if (item.name == "state") {
            item.disabled = false;
          }
          if (item.name == "returnTime") {
            item.type = "datetime";
          }
          if (item.name == "sendTime") {
            item.type = "kong";
          }
        });
      } else if (e == 4) {
        this.forms.state = 2;
        this.items.forEach((item) => {
          if (item.name == "state") {
            item.disabled = true;
          }
          if (item.name == "sendTime") {
            item.type = "datetime";
          }
          if (item.name == "returnTime") {
            item.type = "kong";
          }
        });
      } else {
        this.items.forEach((item) => {
          if (item.name == "state") {
            item.disabled = false;
          }
          if (item.name == "returnTime" || item.name == "sendTime") {
            item.type = "kong";
          }
        });
      }
    },
    async loadWorkCommon() {
      // 通过pk查询字典数据
      let q = {};
      q.workType = 3;
      let res = await $utils.api.load("/admin/system/common/typeList", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.descr;
          xx.name = element.descr;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "teackRemark") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    //选择故障类型下拉框
    async loadTypeData() {
      let q = {};
      q.typeId = this.typeId;
      // 通过pk查询字典数据
      let res = await $utils.api.load("/admin/system/workType/listFrame", q);
      console.log(111, res);
      if (res && res.rows) {
        let list = res.rows;
        if (list.length > 0) {
          let lists = [];
          list.forEach((obj) => {
            lists.push({ name: obj.name, id: obj.id });
            if (obj.deskList && obj.deskList.length > 0) {
              obj.deskList.forEach((item) => {
                const newObj = {
                  name: `${obj.name}-${item.name}`,
                  id: item.id,
                };
                lists.push(newObj);
              });
            }
          });
          let dropList = [];
          for (let index = 0; index < lists.length; index++) {
            const element = lists[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "typeId") {
              this.items[index]["dropList"] = dropList;
            }
          }
          this.forms.typeId = this.typeId;
        }
      }
    },
    handleSubmitKnow() {
      let q = this.forms;
      q.isKnow = 1;
      q.id = this.workId;
      if (this.state || this.state == 3) {
        q.state = 3;
      } else {
        q.state = this.forms.state;
      }
      if (this.forms.typeId) {
        q.typeId = this.forms.typeId;
      } else {
        $utils.toast.error("请选择工单类型!");
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/work/editWork`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$Modal.remove();
                if (q.state == 3) {
                  $utils.url.push({
                    name: "completed_list",
                    path: "completed_list",
                  });
                } else {
                  $utils.url.go(0);
                }
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    handleSubmit() {
      let q = this.forms;
      q.isKnow = 0;
      q.id = this.workId;
      if (this.state || this.state == 3) {
        q.state = 3;
      }
      if (this.forms.typeId) {
        q.typeId = this.forms.typeId;
      } else {
        $utils.toast.error("请选择工单类型!");
        return;
      }
      if (this.forms.avatar) {
        q.avatar = this.forms.avatar;
      }
      if (q.state == 3) {
        q.pcFinish = 2;
      }
      console.log(q);

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/work/editWork`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$Modal.remove();
                if (q.state == 3) {
                  $utils.url.push({
                    name: "completed_list",
                    path: "completed_list",
                  });
                } else {
                  $utils.url.go(0);
                }
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    onTextChange(val) {},
    onTextFocus() {},
    onTextExtClick(v) {
      let _this = this;
      if (v.name === "maintainerContent") {
        this.$refs.change[0].loadData(2);
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open();
          this.$refs.change[0].getText2 = (val) => {
            _this.forms.maintainerContent += val + "";
          };
        }
      } else if (v.name === "teackRemark") {
        this.$refs.change[0].loadData(3);
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open();
          this.$refs.change[0].getText3 = (val) => {
            _this.forms.teackRemark += val + "";
          };
        }
      }
    },
  },
};
</script>

<style lang="less">
.workcolor {
  margin: 5px 5px 5px 150px;
  width: 80px;
  height: 30px;
}

.knowledge {
  width: 125px;
  height: 30px;
  background-color: #1890ff;
  color: #f6f8f7;
  border: none;
  cursor: pointer;
}

.completecolor {
  width: 80px;
  height: 30px;
  margin: 5px 5px 5px 30px;
}
</style>
